import React from "react";
import { Box } from "@mui/material";
import { Typography } from "@mui/material";

const TermsContent = () => {
  return (
    <Box
      sx={{
        height: "calc(100vh - 140px )",
        overflowY: "auto",
        backgroundColor: "#FFFFFF",
        marginTop: "80px",
        paddingRight: "10px",
        paddingBottom: "20px",
      }}
    >
      <Typography
        sx={{
          Height: "32px",
          fontSize: "32px",
          fontWeight: "500 ",
        }}
      >
        Terms & Conditions
      </Typography>
      <Typography
        sx={{
          fontSize: "14px",
          color: "#9E9E9E",
          marginTop: "-8px",
        }}
      >
        Last update at 10/06/2023
      </Typography>
      <Typography
        sx={{
          fontSize: "18px",
          color: "#424242",
          marginTop: "24px",
          fontWeight: "600",
        }}
      >
        Introduction
      </Typography>
      <Typography
        sx={{
          fontSize: "16px",
          color: "#616161",
        }}
      >
        This End User License Agreement ("EULA") is a legal agreement between
        you and AZAD for the use of our application. By accessing or using our
        application, you agree to be bound by the terms and conditions of this
        EULA.  Prohibited Content and Conduct You agree not to use our website
        to create, upload, post, send, or store any content that: Is illegal,
        infringing, or fraudulent Is defamatory, libelous, or threatening Is
        pornographic, obscene, or offensive Is discriminatory or promotes hate
        speech Is harmful to minors Is intended to harass or bully others Is
        intended to impersonate others You also agree not to engage in any
        conduct that: Harasses or bullies others Impersonates others Is intended
        to intimidate or threaten others Is intended to promote or incite
        violence
      </Typography>
      <Typography
        sx={{
          fontSize: "18px",
          color: "#424242",
          marginTop: "24px",
          fontWeight: "600",
        }}
      >
        Consequences of Violation
      </Typography>
      <Typography
        sx={{
          fontSize: "16px",
          color: "#616161",
        }}
      >
        Any violation of this EULA, including the prohibited content and conduct
        outlined above, may result in the termination of your access to our
        website.
      </Typography>
      <Typography
        sx={{
          fontSize: "18px",
          color: "#424242",
          marginTop: "24px",
          fontWeight: "600",
        }}
      >
        Disclaimer of Warranties and Limitation of Liability
      </Typography>
      <Typography
        sx={{
          fontSize: "16px",
          color: "#616161",
        }}
      >
        Our website is provided "as is" and "as available" without warranty of
        any kind, either express or implied, including but not limited to the
        implied warranties of merchantability and fitness for a particular
        purpose. We do not guarantee that our website will be uninterrupted or
        error-free. In no event shall AZAD be liable for any damages whatsoever,
        including but not limited to direct, indirect, special, incidental, or
        consequential damages, arising out of or in connection with the use or
        inability to use our website.
      </Typography>
      <Typography
        sx={{
          fontSize: "18px",
          color: "#424242",
          marginTop: "24px",
          fontWeight: "600",
        }}
      >
        Changes to EULA
      </Typography>
      <Typography
        sx={{
          fontSize: "16px",
          color: "#616161",
        }}
      >
        We reserve the right to update or modify this EULA at any time and
        without prior notice. Your continued use of our website following any
        changes to this EULA will be deemed to be your acceptance of such
        changes.
      </Typography>
      <Typography
        sx={{
          fontSize: "18px",
          color: "#424242",
          marginTop: "24px",
          fontWeight: "600",
        }}
      >
        Contact Information
      </Typography>
      <Typography
        sx={{
          fontSize: "16px",
          color: "#616161",
        }}
      >
        If you have any questions about this EULA, please contact us at
        azadapplication@gmail.com
      </Typography>
      <Typography
        sx={{
          fontSize: "18px",
          color: "#424242",
          marginTop: "24px",
          fontWeight: "600",
        }}
      >
        Acceptance of Terms
      </Typography>
      <Typography
        sx={{
          fontSize: "16px",
          color: "#616161",
        }}
      >
        By using our website, you signify your acceptance of this EULA. If you
        do not agree to this EULA, you may not use our website.
      </Typography>
      <Typography
        sx={{
          fontSize: "18px",
          color: "#424242",
          marginTop: "24px",
          fontWeight: "600",
        }}
      >
        Privacy Policy
      </Typography>
      <Typography
        sx={{
          fontSize: "16px",
          color: "#616161",
        }}
      >
        The following Privacy Policy sets forth Azad’s privacy practices
        regarding its collection, use and sharing of the information that Azad
        collect via your use of Azad’s site or mobile application. Before you
        use the App. and/or submit any information on or through the App.,
        please carefully review this Policy along with our Terms of Use and any
        other documents refer to within this Policy to understand how we will
        collect and utilize your information and your choices about this
        information. By using any part of the App., you consent to our use of
        such information as described in this Policy.
      </Typography>
      <Typography
        sx={{
          fontSize: "18px",
          color: "#424242",
          marginTop: "24px",
          fontWeight: "600",
        }}
      >
        Changes to this Policy
      </Typography>
      <Typography
        sx={{
          fontSize: "16px",
          color: "#616161",
        }}
      >
        We will continue to assess this Policy as we change our offerings or as
        new regulations come into place, and we may make changes to this Policy.
        Any changes will be posted here and you should check this page on
        occasion for updates. We will notify you of any material change to this
        Policy in cases the notification is required by law. Your continued use
        of the Services will signify acceptance of the terms of an updated
        Policy.
      </Typography>
      <Typography
        sx={{
          fontSize: "18px",
          color: "#424242",
          marginTop: "24px",
          fontWeight: "600",
        }}
      >
        External Sites
      </Typography>
      <Typography
        sx={{
          fontSize: "16px",
          color: "#616161",
        }}
      >
        The App. may contain links to other sites and/or mobile applications
        that are owned and operated by third parties. Azad is not responsible
        for the collection or use of information about you at any third-party
        sites or apps. If you choose to click on a link to one of these
        third-party sites or apps, you should review the privacy policy posted
        on the other site or app to understand how they collect and use your
        information.
      </Typography>
      <Typography
        sx={{
          fontSize: "18px",
          color: "#424242",
          marginTop: "24px",
          fontWeight: "600",
        }}
      >
        Collection of information
      </Typography>
      <Typography
        sx={{
          fontSize: "16px",
          color: "#616161",
          lineBreak: "inherit",
        }}
      >
        Information we collect automatically: We may, upon you installing the
        App. , automatically collect information about your device and your use
        of the App., including but not limited to your operating system and your
        device type; the contents you view on our App; searches you do in our
        App; the amount of time spent on particular contents; your Internet
        protocol (“IP”) address, the type of web browser you are using and
        browser language, the dates and times you access our App, crash reports,
        and other similar information. we may use cookies to assist in
        collecting the information. A cookie is a small string of text that a
        website can send to your browser which helps the website remember and
        customize your visit. For example, cookies allow us to tailor the
        content or offers we display to you, in order to better match your
        interests and preferences. With most Internet browsers or other
        software, you can erase cookies from your computer hard drive, block or
        disable cookies or receive a warning before a cookie is stored. Please
        refer to your browser instructions to learn more about these functions
        (e.g., Internet Explorer; Google Chrome; Mozilla Firefox; or Apple
        Safari). Information collected directly from you The information you
        provide to us (upon creating an account) may include but is not limited
        to your username, nick name, and avatar you provide us to create an
        account on the App.; your posts, comments, and reactions; people and
        tables you follow; If you do not want us to collect your information,
        you need to delete your account and/or uninstall the App and we will
        stop doing so. If you delete your account or reject to provide us with
        some information, you may not be able to take advantage of many of the
        App and site's features.
      </Typography>
      <Typography
        sx={{
          fontSize: "18px",
          color: "#424242",
          marginTop: "24px",
          fontWeight: "600",
        }}
      >
        Use of Information
      </Typography>
      <Typography
        sx={{
          fontSize: "16px",
          color: "#616161",
          lineBreak: "inherit",
        }}
      >
        We may use your information to perform our obligations under any
        contract with you (for example, to comply with the terms of use). Some
        other uses are as follows: To measure our performance and for auditing
        and troubleshooting purposes To keep our Site and Application efficient,
        safe and secure; To provide you with all the features and functions of
        App.; For internal research, statistical and user behaviour analytics;
        To provide a smooth, efficient, and personalized experience while using
        our App; To enable your access to your related search history; To notify
        you about a material change to this privacy policy or the Terms of Use,
        if required by law and also service updates; To make recommendations to
        you about contents based on your searches and announced priorities; To
        communicate with users directly
      </Typography>
      <Typography
        sx={{
          fontSize: "18px",
          color: "#424242",
          marginTop: "24px",
          fontWeight: "600",
        }}
      >
        Security
      </Typography>
      <Typography
        sx={{
          fontSize: "16px",
          color: "#616161",
          lineBreak: "inherit",
        }}
      >
        We have taken steps to protect information we collect about you. Some of
        them are as follows: We use encryption such as SLL to protect your data
        while in transit; For signing in/up to your account, we use Google
        authentication procedure; Unfortunately, no safeguards or processes can
        be guaranteed to be 100% secure. Therefore, if you have an account with
        us, you should take steps to protect against unauthorized access to your
        account by, among other things, choosing a robust password that nobody
        else knows or can easily guess and keeping your username and password
        private. We are not responsible for any lost, stolen, or compromised
        passwords or for any activity on your account via unauthorized password
        activity.
      </Typography>
    </Box>
  );
};

export default TermsContent;
